// src/adapters/eec-carline-ranges/eec-carline-ranges.adapter.ts
function eecCarlineRangeToCaEInput(carline) {
  if (carline.eecModel.isHybrid) {
    return mapHybrid(carline);
  }
  return mapDefault(carline);
}
function mapDefault(carline) {
  const {
    isPureElectric,
    fuelConsumptionWltpCombinedMin,
    fuelConsumptionWltpCombinedMax,
    fuelConsumptionWltpUnit,
    electricConsumptionWltpCombinedMin,
    electricConsumptionWltpCombinedMax,
    electricConsumptionWltpCombinedUnit,
    co2EmissionWltpCombinedMin,
    co2EmissionWltpCombinedMax,
    co2EmissionWltpCombinedUnit,
    eecClassCombinedMin,
    eecClassCombinedMax
  } = carline.eecModel;
  const consumption = isPureElectric ? {
    fuelType: "ELECTRICAL",
    min: electricConsumptionWltpCombinedMin,
    max: electricConsumptionWltpCombinedMax,
    unit: electricConsumptionWltpCombinedUnit
  } : {
    fuelType: "PETROL",
    min: fuelConsumptionWltpCombinedMin,
    max: fuelConsumptionWltpCombinedMax,
    unit: fuelConsumptionWltpUnit
  };
  if (typeof consumption.min === "number" && typeof consumption.max === "number" && consumption.unit && typeof co2EmissionWltpCombinedMax === "number" && typeof co2EmissionWltpCombinedMin === "number" && co2EmissionWltpCombinedUnit) {
    return {
      type: "RAW",
      data: {
        fuels: [
          {
            fuelType: consumption.fuelType,
            consumption: {
              type: "RANGE",
              max: consumption.max,
              min: consumption.min,
              unit: consumption.unit
            },
            emissionCO2: {
              type: "RANGE",
              max: co2EmissionWltpCombinedMax,
              min: co2EmissionWltpCombinedMin,
              unit: co2EmissionWltpCombinedUnit
            }
          }
        ],
        eec: eecClassCombinedMin && eecClassCombinedMax ? {
          type: "RANGE",
          min: eecClassCombinedMin,
          max: eecClassCombinedMax
        } : void 0
      }
    };
  }
  return {
    type: "PREFORMATTED",
    data: {
      template: isPureElectric ? "ELECTRICAL" : "ICE",
      consumption: carline.eecModel.eecFuelValue,
      emissionCO2: carline.eecModel.eecCo2Value
    }
  };
}
function mapHybrid(carline) {
  const {
    fuelConsumptionWltpCombinedMin,
    fuelConsumptionWltpCombinedMax,
    fuelConsumptionWltpUnit,
    co2EmissionWltpCombinedMin,
    co2EmissionWltpCombinedMax,
    co2EmissionWltpCombinedUnit,
    wltpSustainingCombinedMin,
    wltpSustainingCombinedMax,
    electricConsumptionWltpCombinedMin,
    electricConsumptionWltpCombinedMax,
    electricConsumptionWltpCombinedUnit,
    eecClassCombinedMin,
    eecClassCombinedMax,
    eecClassSustainingMin,
    eecClassSustainingMax
  } = carline.eecModel;
  if (typeof fuelConsumptionWltpCombinedMax === "number" && typeof fuelConsumptionWltpCombinedMin === "number" && fuelConsumptionWltpUnit && typeof co2EmissionWltpCombinedMax === "number" && typeof co2EmissionWltpCombinedMin === "number" && co2EmissionWltpCombinedUnit && typeof electricConsumptionWltpCombinedMax === "number" && typeof electricConsumptionWltpCombinedMin === "number" && electricConsumptionWltpCombinedUnit) {
    return {
      type: "RAW",
      data: {
        fuels: [
          {
            // Currently not possible to determine the fuel type from the data, but should not affect the output anyway
            // Probably, because there are diesel and petrol versions within a carline
            fuelType: "PETROL",
            consumption: {
              type: "RANGE",
              min: fuelConsumptionWltpCombinedMin,
              max: fuelConsumptionWltpCombinedMax,
              unit: fuelConsumptionWltpUnit
            },
            emissionCO2: {
              type: "RANGE",
              min: co2EmissionWltpCombinedMin,
              max: co2EmissionWltpCombinedMax,
              unit: co2EmissionWltpCombinedUnit
            },
            consumptionSustaining: wltpSustainingCombinedMin && wltpSustainingCombinedMax ? {
              type: "RANGE",
              min: wltpSustainingCombinedMin,
              max: wltpSustainingCombinedMax,
              unit: fuelConsumptionWltpUnit
            } : void 0,
            emissionCO2Sustaining: void 0
            // Not available in the data
          },
          {
            fuelType: "ELECTRICAL",
            consumption: {
              type: "RANGE",
              min: electricConsumptionWltpCombinedMin,
              max: electricConsumptionWltpCombinedMax,
              unit: electricConsumptionWltpCombinedUnit
            },
            emissionCO2: void 0
          }
        ],
        eec: eecClassCombinedMin && eecClassCombinedMax ? {
          type: "RANGE",
          min: eecClassCombinedMin,
          max: eecClassCombinedMax
        } : void 0,
        eecSustaining: eecClassSustainingMin && eecClassSustainingMax ? {
          type: "RANGE",
          min: eecClassSustainingMin,
          max: eecClassSustainingMax
        } : void 0
      }
    };
  }
  return {
    type: "PREFORMATTED",
    data: {
      template: "HYBRID",
      consumption: carline.eecModel.eecFuelValue,
      emissionCO2: carline.eecModel.eecCo2Value
    }
  };
}

// src/adapters/consumptions-and-emissions/consumption-and-emissions.adapter.ts
function consumptionAndEmissionsToCaEInput(cae) {
  return {
    fuels: (cae.fuels ?? []).map((fuel) => tryConvertFuelEntryToFuelInput(fuel)).filter((fuel) => fuel !== void 0),
    eec: cae.eec ? { type: "VALUE", value: cae.eec } : void 0,
    eecSustaining: cae.eecSustaining ? { type: "VALUE", value: cae.eecSustaining } : void 0
  };
}
function tryConvertFuelEntryToFuelInput(fuelEntry) {
  const consumptionConsolidated = fuelEntry?.consumption?.wltp?.consolidated;
  const consumptionUnit = consumptionConsolidated?.unit;
  const consumption = consumptionConsolidated?.value?.number;
  const emissionConsolidated = fuelEntry?.emission?.co2?.wltp?.consolidated;
  const emission = emissionConsolidated?.value?.number;
  const emissionUnit = emissionConsolidated?.unit;
  const consumptionSustaining = fuelEntry.consumption?.wltp?.dataSets?.find((dataSet) => dataSet.em === "SUSTAINING")?.values?.combined?.number;
  const emissionSustaining = fuelEntry.emission?.co2?.wltp?.dataSets?.find((dataSet) => dataSet.em === "SUSTAINING")?.values?.combined?.number;
  return {
    fuelType: fuelEntry.fuel,
    consumption: consumption !== void 0 ? { type: "VALUE", value: consumption, unit: consumptionUnit } : void 0,
    emissionCO2: emission !== void 0 ? {
      type: "VALUE",
      value: emission,
      unit: emissionUnit
    } : void 0,
    consumptionSustaining: consumptionSustaining !== void 0 ? { type: "VALUE", value: consumptionSustaining, unit: consumptionUnit } : void 0,
    emissionCO2Sustaining: emissionSustaining !== void 0 ? { type: "VALUE", value: emissionSustaining, unit: emissionUnit } : void 0
  };
}

// src/adapters/carline-fuel-measurement/carline-fuel-measurement.adapter.ts
function carlineFuelMeasurementToCaEInput(input) {
  const measurements = input.measurements || {};
  const electric = findRelevantCaEValues(measurements["range-electric"] || []);
  const fuel = findRelevantCaEValues(measurements["range-benzin-diesel"] || measurements["range-cng"] || []);
  const fuelSustaining = findRelevantCaEValues(
    measurements["range-benzin-diesel.SUSTAINING"] || measurements["range-cng.SUSTAINING"] || []
  );
  const fuels = [];
  if (typeof electric.consumption?.max === "number" && typeof electric.consumption?.min === "number") {
    fuels.push({
      fuelType: "ELECTRICAL",
      consumption: {
        type: "RANGE",
        max: electric.consumption.max,
        min: electric.consumption.min,
        unit: electric.consumption.unit
      },
      emissionCO2: typeof electric.emissionCo2?.max === "number" && typeof electric.emissionCo2?.min === "number" ? {
        type: "RANGE",
        max: electric.emissionCo2.max,
        min: electric.emissionCo2.min,
        unit: electric.emissionCo2.unit
      } : void 0
    });
  }
  if (typeof fuel.consumption?.max === "number") {
    fuels.push({
      fuelType: "PETROL",
      // Cannot differentiate between petrol and diesel, but not matter currently
      consumption: {
        type: "RANGE",
        max: fuel.consumption.max,
        min: fuel.consumption.min,
        unit: fuel.consumption.unit
      },
      emissionCO2: typeof fuel.emissionCo2?.max === "number" && typeof fuel.emissionCo2?.min === "number" ? {
        type: "RANGE",
        max: fuel.emissionCo2.max,
        min: fuel.emissionCo2.min,
        unit: fuel.emissionCo2.unit
      } : void 0,
      consumptionSustaining: typeof fuelSustaining.consumption?.max === "number" && typeof fuelSustaining.consumption?.min === "number" ? {
        type: "RANGE",
        max: fuelSustaining.consumption.max,
        min: fuelSustaining.consumption.min,
        unit: fuelSustaining.consumption.unit
      } : void 0,
      emissionCO2Sustaining: typeof fuelSustaining.emissionCo2?.max === "number" && typeof fuelSustaining.emissionCo2?.min === "number" ? {
        type: "RANGE",
        max: fuelSustaining.emissionCo2.max,
        min: fuelSustaining.emissionCo2.min,
        unit: fuelSustaining.emissionCo2.unit
      } : void 0
    });
  }
  return {
    fuels,
    eec: input.efficiencyClassRanges ? {
      type: "RANGE",
      max: input.efficiencyClassRanges.max,
      min: input.efficiencyClassRanges.min
    } : void 0,
    eecSustaining: input.efficiencyClassSustainingRanges ? {
      type: "RANGE",
      max: input.efficiencyClassSustainingRanges.max,
      min: input.efficiencyClassSustainingRanges.min
    } : void 0
  };
}
function findRelevantCaEValues(ranges) {
  return {
    consumption: ranges.find((r) => r.domain === "WLTP_CONSUMPTION" && r.type === "WLTP_COMBINED"),
    emissionCo2: ranges.find((r) => r.domain === "WLTP_CO2" && r.type === "WLTP_COMBINED")
  };
}

// src/internals/locale.ts
function createLocale({
  country,
  language,
  locale
}) {
  return locale || `${language}-${country.toUpperCase()}`;
}

// src/cae-value-formatter.ts
function createConsumptionAndEmissionValueFormatter(params) {
  return new ConsumptionAndEmissionValueFormatterImpl(createLocale(params), params.i18nResources ?? {});
}
var ConsumptionAndEmissionValueFormatterImpl = class {
  consumptionFormatter;
  emissionFormatter;
  templates;
  constructor(locale, templates) {
    this.consumptionFormatter = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    });
    this.emissionFormatter = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    this.formatConsumption = this.consumptionFormatter.format.bind(this.consumptionFormatter);
    this.formatEmission = this.emissionFormatter.format.bind(this.emissionFormatter);
    this.templates = templates;
  }
  formatConsumption(value) {
    return this.consumptionFormatter.format(value);
  }
  formatEmission(value) {
    return this.emissionFormatter.format(value);
  }
  formatMeasurement(measurement, formatFn) {
    const unit = measurement.unit ? this.templates[`cae.unit.${measurement.unit}`] ?? measurement.unit : measurement.unit;
    const unitOrEmpty = unit ? ` ${unit}` : "";
    if (measurement.type === "VALUE") {
      return formatFn(measurement.value) + unitOrEmpty;
    }
    if (measurement.max === measurement.min) {
      return formatFn(measurement.max) + unitOrEmpty;
    }
    return `${formatFn(measurement.max)}\u2013${formatFn(measurement.min)}` + unitOrEmpty;
  }
  formatMeasurementWithoutUnit(measurement) {
    if (measurement.type === "VALUE") {
      return measurement.value;
    }
    if (measurement.max === measurement.min) {
      return measurement.max;
    }
    return `${measurement.max}\u2013${measurement.min}`;
  }
};

// src/internals/footnote.ts
var DEFAULT_FOOTNOTE = {
  text: "<sup>{{ft_nemo-fn_eec-global-disclaimer}}</sup>",
  reference: "ft_nemo-fn_eec-global-disclaimer"
};

// src/internals/disclaimers.ts
var CreateDisclaimerStrategies = {
  /**
   * Adds consumption and emission related disclaimers to the given result object.
   */
  default: ({ input, result, formatter, templates }) => {
    const electricalFuel = input.fuels.find((f) => f.fuelType === "ELECTRICAL");
    const nonElectricalFuel = input.fuels.find((f) => f.fuelType !== "ELECTRICAL");
    if (electricalFuel && nonElectricalFuel && electricalFuel.consumption && nonElectricalFuel.consumption) {
      result.formattedConsumption = combineLabelWithValue(
        templates.render("cae.consumption.hybrid.default.label", { footnote: DEFAULT_FOOTNOTE.text }),
        templates.render("cae.consumption.hybrid.default.value", {
          electrical: {
            fuel: templates.getTemplate(`cae.ELECTRICAL`),
            consumption: formatter.formatMeasurement(electricalFuel.consumption, formatter.formatConsumption)
          },
          nonElectrical: {
            fuel: templates.getTemplate(`cae.${nonElectricalFuel.fuelType}`),
            consumption: formatter.formatMeasurement(nonElectricalFuel.consumption, formatter.formatConsumption)
          },
          footnote: DEFAULT_FOOTNOTE.text
        })
      );
      result.formattedEmission = nonElectricalFuel.emissionCO2 ? combineLabelWithValue(
        templates.render("cae.emission.hybrid.default.label", { footnote: DEFAULT_FOOTNOTE.text }),
        templates.render("cae.emission.hybrid.default.value", {
          emission: formatter.formatMeasurement(nonElectricalFuel.emissionCO2, formatter.formatEmission)
        })
      ) : void 0;
      if (nonElectricalFuel.consumptionSustaining) {
        result.formattedDischargedConsumption = combineLabelWithValue(
          templates.render("cae.consumption.hybrid.sustaining.label", { footnote: DEFAULT_FOOTNOTE.text }),
          templates.render("cae.consumption.hybrid.sustaining.value", {
            consumption: formatter.formatMeasurement(
              nonElectricalFuel.consumptionSustaining,
              formatter.formatConsumption
            )
          })
        );
      }
      if (nonElectricalFuel.emissionCO2Sustaining) {
        result.formattedDischargedEmission = combineLabelWithValue(
          templates.render("cae.emission.hybrid.sustaining.label", { footnote: DEFAULT_FOOTNOTE.text }),
          templates.render("cae.emission.hybrid.sustaining.value", {
            emission: formatter.formatMeasurement(nonElectricalFuel.emissionCO2Sustaining, formatter.formatEmission)
          })
        );
      }
    } else {
      const fuel = electricalFuel || nonElectricalFuel;
      if (!fuel) {
        return result;
      }
      if (fuel.consumption) {
        const consumptionTemplate = fuel.fuelType === "ELECTRICAL" ? {
          label: "cae.consumption.electric.label",
          value: "cae.consumption.electric.value"
        } : {
          label: "cae.consumption.default.label",
          value: "cae.consumption.default.value"
        };
        result.formattedConsumption = combineLabelWithValue(
          templates.render(consumptionTemplate.label, { footnote: DEFAULT_FOOTNOTE.text }),
          templates.render(consumptionTemplate.value, {
            consumption: formatter.formatMeasurement(fuel.consumption, formatter.formatConsumption)
          })
        );
      }
      if (fuel.emissionCO2) {
        result.formattedEmission = combineLabelWithValue(
          templates.render("cae.emission.default.label", { footnote: DEFAULT_FOOTNOTE.text }),
          templates.render("cae.emission.default.value", {
            emission: formatter.formatMeasurement(fuel.emissionCO2, formatter.formatEmission)
          })
        );
      }
    }
    return result;
  },
  /**
   * Adds EEC related disclaimers to the given result object.
   */
  withEec: ({ input, result, formatter, templates }) => {
    if (input.fuels.length > 1) {
      if (input.eec) {
        const eecTemplate = isRealRange(input.eec) ? {
          label: "cae.eec.hybrid.range.label",
          value: "cae.eec.hybrid.range.value"
        } : {
          label: "cae.eec.hybrid.default.label",
          value: "cae.eec.hybrid.default.value"
        };
        result.formattedCo2Class = combineLabelWithValue(
          templates.render(eecTemplate.label, { footnote: DEFAULT_FOOTNOTE.text }),
          templates.render(eecTemplate.value, {
            eec: formatter.formatMeasurementWithoutUnit(input.eec)
          })
        );
      }
      if (input.eecSustaining) {
        result.formattedDischargedCo2Class = combineLabelWithValue(
          isRealRange(input.eecSustaining) ? templates.render("cae.eec.hybrid.sustaining.range.label", { footnote: DEFAULT_FOOTNOTE.text }) : templates.render("cae.eec.hybrid.sustaining.label", { footnote: DEFAULT_FOOTNOTE.text }),
          formatter.formatMeasurementWithoutUnit(input.eecSustaining)
        );
      }
    } else {
      if (input.eec) {
        const eecTemplate = isRealRange(input.eec) ? {
          label: "cae.eec.range.label",
          value: "cae.eec.range.value"
        } : {
          label: "cae.eec.default.label",
          value: "cae.eec.default.value"
        };
        result.formattedCo2Class = combineLabelWithValue(
          templates.render(eecTemplate.label, { footnote: DEFAULT_FOOTNOTE.text }),
          templates.render(eecTemplate.value, {
            eec: formatter.formatMeasurementWithoutUnit(input.eec)
          })
        );
      }
    }
    return result;
  }
};
function createDisclaimersFromPreformattedValues({
  input,
  templates
}) {
  const result = {
    footnote: DEFAULT_FOOTNOTE
  };
  const consumptionLabel = (() => {
    switch (input.template) {
      case "ELECTRICAL":
        return "cae.consumption.electric.label";
      case "HYBRID":
        return "cae.consumption.hybrid.default.label";
      default:
        return "cae.consumption.default.label";
    }
  })();
  result.formattedConsumption = combineLabelWithValue(
    templates.render(consumptionLabel, { footnote: DEFAULT_FOOTNOTE.text }),
    input.consumption
  );
  if (input.emissionCO2) {
    const emissionLabel = input.template === "HYBRID" ? "cae.emission.hybrid.default.label" : "cae.emission.default.label";
    result.formattedEmission = combineLabelWithValue(
      templates.render(emissionLabel, { footnote: DEFAULT_FOOTNOTE.text }),
      input.emissionCO2
    );
  }
  return result;
}
function isRealRange(range) {
  return range.type === "RANGE" && range.min !== range.max;
}
function combineLabelWithValue(label, value) {
  if (!label || !value) {
    return void 0;
  }
  return `${label}: ${value}`;
}

// src/internals/templates.ts
import Mustache from "mustache";
var CaETemplateRenderer = class {
  templates;
  renderConfig = { escape: (unescaped) => unescaped };
  constructor(templates) {
    this.templates = templates;
  }
  /**
   * Returns the value of the template with the given id.
   * @example getTemplate("cae.consumption.default") => "Kraftstoffverbrauch (kombiniert): {{consumption}}"
   */
  getTemplate(id) {
    return this.templates[id];
  }
  /**
   * Renders the template with the given data.
   * The input data type will be inferred based on the template id.
   *
   * @example
   * render("cae.consumption.default", { consumption: "10,0 l/100 km" });
   */
  render(id, data) {
    const template = this.getTemplate(id);
    if (!template) {
      return void 0;
    }
    return Mustache.render(template, data, void 0, this.renderConfig);
  }
};

// src/cae-disclaimer-formatter.ts
function createConsumptionAndEmissionDisclaimerFormatter(params) {
  const country = params.country.toLocaleUpperCase();
  return new ConsumptionAndEmissionDisclaimerFormatterImpl({
    country,
    language: params.language,
    locale: params.locale,
    templates: params.i18nResources,
    disclaimerStrategies: [CreateDisclaimerStrategies.default, CreateDisclaimerStrategies.withEec]
  });
}
var ConsumptionAndEmissionDisclaimerFormatterImpl = class {
  formatter;
  templates;
  disclaimerStrategies;
  constructor(params) {
    this.formatter = new ConsumptionAndEmissionValueFormatterImpl(createLocale(params), params.templates);
    this.templates = new CaETemplateRenderer(params.templates);
    this.disclaimerStrategies = params.disclaimerStrategies;
  }
  createDisclaimers(params) {
    const result = {
      footnote: {
        reference: DEFAULT_FOOTNOTE.reference
      }
    };
    for (const strategy of this.disclaimerStrategies) {
      strategy({
        input: params,
        result,
        formatter: this.formatter,
        templates: this.templates
      });
    }
    return result;
  }
  createDisclaimersFromPreformatted(params) {
    const result = createDisclaimersFromPreformattedValues({
      input: params,
      templates: this.templates
    });
    return result;
  }
};
export {
  carlineFuelMeasurementToCaEInput,
  consumptionAndEmissionsToCaEInput,
  createConsumptionAndEmissionDisclaimerFormatter,
  createConsumptionAndEmissionValueFormatter,
  eecCarlineRangeToCaEInput
};
//# sourceMappingURL=index.js.map